import type { RouterProps } from 'contracts/Router';
import { Navigate, Outlet, RouteObject } from 'react-router-dom';

// guest
import loginRoute from './guest/login';
import forgotMyPasswordRoute from './guest/forgotMyPassword';
import passwordResetRoute from './guest/passwordReset';

// authenticated
import adminsRoutes from './admins';
import dashboardRoutes from './dashboard';
import checklistRoutes from './checklist';
import cancelationReasonsRoutes from './cancelationReasons';
import cargoTypesRoutes from './cargoTypes';
import carrierMemberRoutes from './carrierMembers';
import carriersRoutes from './carriers';
import companiesRoutes from './companies';
import companyMemberRoutes from './companyMembers';
import dockReservedIntervalsRoutes from './dockReservedIntervals';
import operationTypesRoutes from './operationTypes';
import schedulingRoutes from './scheduling';
import vehicleSetupsRoutes from './vehicleSetups';
import vehicleTypesRoutes from './vehicleTypes';
import warehouseMemberRoutes from './warehouseMembers';
import warehousesRoutes from './warehouses';
import warehouseOrderEventAutomationsRoutes from './warehouseOrderEventAutomations';
import areasRoutes from './areas';
import alertEmailLogsRoutes from './alertEmailLogs';
import checklistMemberRoutes from './checklistMembers';
import checklistTemplatesRoutes from './checklistTemplates';
import vehicleJourneyRoutes from './vehicleJourney';
import portariaRoute from './portaria';
import fidsRoute from './fids';
import orderImportsRoutes from './orderImports';

import { MyAccountPage } from 'pages/Account';
import documentsRoutes from './documents';
import HomeRedirect from 'components/Pages/HomeRedirect';

const routes = (props: RouterProps): RouteObject[] => {
  const { isLoggedIn, location } = props;
  return [
    {
      path: '/',
      element: isLoggedIn ? (
        <Outlet />
      ) : (
        <Navigate to="/login" state={{ from: location }} />
      ),
      children: [
        // settings routes
        adminsRoutes(props),
        dashboardRoutes(props),
        checklistRoutes(props),
        checklistMemberRoutes(props),
        checklistTemplatesRoutes(props),
        carrierMemberRoutes(props),
        carriersRoutes(props),
        companiesRoutes(props),
        companyMemberRoutes(props),
        warehousesRoutes(props),
        warehouseOrderEventAutomationsRoutes(props),
        areasRoutes(props),
        warehouseMemberRoutes(props),
        vehicleSetupsRoutes(props),
        vehicleTypesRoutes(props),
        cargoTypesRoutes(props),
        operationTypesRoutes(props),
        cancelationReasonsRoutes(props),
        dockReservedIntervalsRoutes(props),
        documentsRoutes(props),
        alertEmailLogsRoutes(props),
        vehicleJourneyRoutes(props),
        portariaRoute(),
        fidsRoute(props),
        orderImportsRoutes(props),
        {
          path: 'configuracoes',
          element: <Navigate to="/configuracoes/clientes" />,
        },
        // end settings routes
        schedulingRoutes(props),
        {
          path: 'meus-dados',
          element: <MyAccountPage />,
        },
        {
          path: '',
          element: <HomeRedirect />,
        },
      ],
    },
    loginRoute(props),
    forgotMyPasswordRoute(props),
    passwordResetRoute(props),
  ];
};

export default routes;
